import React, { useEffect, useState } from 'react';

const emptyWord = {
  front_text: '',
  back_text: '',
  example_sentence: '',
  english_variant: 'british',
  part_of_speech: 'noun',
  etymology: '',
  target_band: '6.0',
  related_forms: ''
};

function WordForm({ selected, onSave, onCancel }) {
  const [form, setForm] = useState(emptyWord);

  const update = (key, value) =>
    setForm((current) => ({ ...current, [key]: value }));

  useEffect(() => {
    setForm(selected ? { ...emptyWord, ...selected } : emptyWord);
  }, [selected]);

  const submit = async (event) => {
    event.preventDefault();
    await onSave({ ...form, target_band: Number(form.target_band) });

    if (!selected) {
      setForm(emptyWord);
    }
  };

  return (
    <form className="admin-form" onSubmit={submit}>
      <div className="form-heading">
        <h2>{selected ? 'Edit word' : 'Add a word'}</h2>
        <p>Fields marked required appear on the study card.</p>
      </div>

      <div className="form-grid three">
        <label>
          Front text
          <input
            required
            value={form.front_text}
            onChange={(event) => update('front_text', event.target.value)}
          />
        </label>

        <label>
          Back text
          <input
            required
            value={form.back_text}
            onChange={(event) => update('back_text', event.target.value)}
          />
        </label>

        <label>
          English variant
          <select
            value={form.english_variant}
            onChange={(event) =>
              update('english_variant', event.target.value)
            }
          >
            <option value="british">British</option>
            <option value="american">American</option>
          </select>
        </label>

        <label>
          Part of speech
          <select
            value={form.part_of_speech}
            onChange={(event) =>
              update('part_of_speech', event.target.value)
            }
          >
            <option>noun</option>
            <option>verb</option>
            <option>adjective</option>
            <option>adverb</option>
            <option>phrase</option>
          </select>
        </label>

        <label>
          Target band
          <input
            type="number"
            min="5"
            max="9"
            step="0.5"
            required
            value={form.target_band}
            onChange={(event) => update('target_band', event.target.value)}
          />
        </label>

        <label className="span-two">
          Example sentence
          <textarea
            required
            value={form.example_sentence}
            onChange={(event) =>
              update('example_sentence', event.target.value)
            }
          />
        </label>

        <label>
          Related forms
          <textarea
            value={form.related_forms}
            onChange={(event) => update('related_forms', event.target.value)}
          />
        </label>

        <label className="span-full">
          Word origin <span className="optional">(optional)</span>
          <textarea
            value={form.etymology}
            onChange={(event) => update('etymology', event.target.value)}
          />
        </label>
      </div>

      <div className="form-actions">
        {selected && (
          <button type="button" className="button ghost" onClick={onCancel}>
            Cancel
          </button>
        )}
        <button className="button primary">
          {selected ? 'Save changes' : 'Add word'}
        </button>
      </div>
    </form>
  );
}

export default WordForm;